import * as React from "react";
import * as ReactDOM from "react-dom/client";


function getHospitalInfo(): { address: string; hospitalName: string } | null {
    const addressElement = document.getElementsByClassName(
        "hospitalAddress"
    )[0] as HTMLElement;
    const hospitalNameElement = document.getElementsByClassName(
        "hospitalName"
    )[0] as HTMLElement;

    if (addressElement && hospitalNameElement) {
        return {
            address: addressElement.innerText,
            hospitalName: hospitalNameElement.innerText,
        };
    } else {
        return null;
    }
}

const GoogleMap: React.FunctionComponent<{
    address: string;
    width: number;
    height: number;
}> = ({ address, width, height }) => {
    const src = "https://maps.google.com/maps?q=" + address + "&output=embed";

    return (
        <div className="inline-block map-container">
            <div className="hospital-map">
                <iframe
                    id="mapframe"
                    src={src}
                    frameBorder="0"
                    scrolling="no"
                    width={width}
                    height={height}
                    marginHeight={0}
                    marginWidth={0}
                    title="Location Map"
                ></iframe>
            </div>
        </div>
    );
};

const HospitalMap: React.FunctionComponent<{
    dimensions: { height: number; width: number };
}> = ({ dimensions }) => {
    const hospitalInfo = getHospitalInfo();

    if (!hospitalInfo || (!hospitalInfo.address && !hospitalInfo.hospitalName)) {
        return <></>;
    }

    return (
        <GoogleMap
            address={hospitalInfo.address}
            width={dimensions.width}
            height={dimensions.height}
        />
    );
};

export function initHospitalMap() {
    const mapRoot: HTMLElement | null  = document.getElementById("google-map");
    const dimensions: {
        height: number;
        width: number;
    } = { height: 170, width: 150 };


    if (mapRoot) {
        const root = ReactDOM.createRoot(mapRoot);

        root.render(
            <>
                <HospitalMap dimensions={dimensions}></HospitalMap>
            </>
        );
    }
}
